import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.219 3.41c-1.583-1.584-4.156-1.529-5.747.062-1.59 1.59-1.646 4.164-.063 5.747l3.807 3.807a.75.75 0 1 0 1.06-1.061L4.47 8.158c-.97-.97-.97-2.593.063-3.625s2.655-1.034 3.625-.063l4.382 4.382.003.003c.97.97.969 2.593-.063 3.625a.75.75 0 0 0 1.06 1.06c1.59-1.589 1.646-4.16.067-5.743l-.004-.003z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.731 20.541c1.583 1.583 4.156 1.528 5.747-.063 1.59-1.59 1.646-4.164.063-5.747l-3.807-3.806a.75.75 0 1 0-1.06 1.06l3.806 3.807c.97.97.97 2.594-.063 3.626s-2.655 1.033-3.625.062l-4.382-4.382-.003-.002c-.97-.97-.969-2.594.063-3.626a.75.75 0 0 0-1.06-1.06c-1.59 1.59-1.646 4.16-.066 5.743l.003.003z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }